import { PlaceUserDto } from 'gleblu-socket-api';

import PlaceUser from '../interfaces/PlaceUser';

export function fromDto(placeUser: PlaceUserDto): PlaceUser {
  const { uuid, firstName, lastName, email, phoneNumber, emailVerified, type, selectedLanguage } = placeUser;
  return {
    uuid,
    firstName,
    lastName,
    email,
    phoneNumber,
    emailVerified,
    type,
    selectedLanguage,
  };
}

export function toDto(placeUser: PlaceUser): PlaceUserDto {
  const { uuid, firstName, lastName, email, phoneNumber, emailVerified, type, selectedLanguage } = placeUser;
  return {
    uuid,
    firstName,
    lastName,
    email,
    phoneNumber,
    emailVerified,
    type,
    selectedLanguage,
  };
}
